module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/babel-runtime/core-js/object/create.js
 ** module id = 285
 ** module chunks = 0
 **/